import { render, staticRenderFns } from "./child-file-setting-add.vue?vue&type=template&id=6157e61d&scoped=true&"
import script from "./child-file-setting-add.vue?vue&type=script&lang=js&"
export * from "./child-file-setting-add.vue?vue&type=script&lang=js&"
import style0 from "./child-file-setting-add.vue?vue&type=style&index=0&id=6157e61d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6157e61d",
  null
  
)

export default component.exports